import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalScrollComponent } from './horizontal-scroll/horizontal-scroll.component';
import { HorizontalScrollItemDirective } from './horizontal-scroll/horizontal-scroll-item.directive';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DlsButtonModule } from '@zelis/dls/button';
import { MatIconModule } from '@angular/material/icon';
import { DlsDotsModule } from '@zelis/dls/dots';

@NgModule({
  imports: [
    CommonModule,
    DlsButtonModule,
    DlsDotsModule,
    MatIconModule,
    NgxPageScrollModule,
  ],
  declarations: [HorizontalScrollComponent, HorizontalScrollItemDirective],
  exports: [HorizontalScrollComponent, HorizontalScrollItemDirective],
})
export class DlsHorizontalScrollModule {}
